module.exports = __webpack_public_path__ + "static/media/jf656v56.127832a4.png";